<div>
  <div class="px-0 py-0">
    @if (!metadataFetchError()) {
      <p class="my-0">
        Please check the metadata your results will be published with. <br />
        If you want to permanently set your author details, you can do so on
        your <a routerLink="/user-profile">profile page</a>.
      </p>
    } @else {
      We could not upload metadata from our database. You can still provide
      proper information and publish your results. However, if the problem
      persists, please contact our support team.
    }
  </div>
  <form [formGroup]="publishingForm">
    <div class="pt-3 pb-2 grid">
      <span class="label col-2">
        <label for="title">Title</label>
      </span>
      <textarea
        class="form-field col"
        id="title"
        type="text"
        pInputText
        formControlName="title"
      >
      </textarea>
      <span
        pTooltip="Title of the Zenodo entry"
        class="pi pi-question-circle col-1 help-field"
      >
      </span>
    </div>

    <div class="py-2 grid">
      <span class="label col-2">
        <label for="description">Description</label>
      </span>
      <textarea
        class="form-field col"
        id="description"
        type="text"
        pInputText
        formControlName="description"
      >
      </textarea>
      <span
        pTooltip="Description of the Zenodo entry"
        class="pi pi-question-circle col-1 help-field"
      >
      </span>
    </div>

    <div class="py-2 grid">
      <span class="label col-2">
        <label for="keywords">Keywords</label>
      </span>
      <textarea
        class="form-field col"
        id="keywords"
        type="text"
        pInputText
        formControlName="keywords"
      >
      </textarea>
      <span
        pTooltip="Comma-separated list of keywords to make your results easily searchable; must contain keyword 'qa4sm'"
        class="pi pi-question-circle col-1 help-field"
      >
      </span>
    </div>
    @if (formErrors && formErrors.keywords) {
      <div class="alert">
        @for (error of formErrors.keywords; track error) {
          <span>{{ error.message }}<br /></span>
        }
      </div>
    }

    <div class="py-2 grid">
      <span class="label col-2">
        <label for="name">Name</label>
      </span>
      <input
        class="form-field col"
        id="name"
        type="text"
        pInputText
        formControlName="name"
      />
      <span
        pTooltip="Your name; format: Lastname, Firstnames"
        class="pi pi-question-circle col-1 help-field"
      >
      </span>
    </div>

    <div class="py-2 grid">
      <span class="label col-2">
        <label for="affiliation">Affiliation</label>
      </span>
      <input
        class="form-field col"
        id="affiliation"
        type="text"
        pInputText
        formControlName="affiliation"
      />
      <span
        pTooltip="Your organisation or other affiation, optional"
        class="pi pi-question-circle col-1 help-field"
      >
      </span>
    </div>

    <div class="pt-2 mb-3 grid">
      <span class="label col-2">
        <label for="orcid">ORCID</label>
      </span>
      <input
        class="form-field col"
        id="orcid"
        type="text"
        pInputText
        formControlName="orcid"
      />
      <span
        pTooltip="Your personal ORCID id, optional"
        class="pi pi-question-circle col-1 help-field"
      >
      </span>
    </div>
    @if (formErrors && formErrors.orcid) {
      <div class="alert">
        @for (error of formErrors.orcid; track error) {
          <span>{{ error.message }}<br /></span>
        }
      </div>
    }
    <b>Please note:</b>
    Publishing the result can't be undone and you won't be able to delete the
    result nor change its metadata (including the validation name) later.<br />
    Publishing can take a few minutes, please be patient.

    <div style="text-align: right">
      <button
        pButton
        id="cancel-button"
        (click)="handleModalWindow(false)"
        label="Cancel"
      ></button>
      <button
        pButton
        id="submit-button"
        (click)="publish()"
        label="Publish now!"
        [disabled]="!publishingForm.valid"
      ></button>
    </div>
  </form>
</div>
